import { Flex, forwardRef, Heading, Stack, StackProps } from '@chakra-ui/react';
import { __DEV__ } from '@chakra-ui/utils';
import { ReactNode } from 'react';

export interface IPanelProps extends StackProps {
  heading: ReactNode;
  subheading?: ReactNode;
  action?: ReactNode;
}

export const Panel = forwardRef<IPanelProps, typeof Stack>((props, ref) => {
  const { heading, subheading, action, children, ...rest } = props;

  return (
    <Stack spacing={[6, null, 8]} ref={ref} {...rest}>
      <Flex justifyContent="space-between" alignItems={{ base: 'flex-end', lg: 'flex-start' }}>
        <Flex w="full" flexDir="column">
          {heading}
          {subheading}
        </Flex>
        <Flex justifyContent="flex-end">{action}</Flex>
      </Flex>
      {children}
    </Stack>
  );
});

if (__DEV__) {
  Panel.displayName = 'Panel';
}
